export default {
      id: "oc-ceph-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-ceph",
      toString: function () {
        return this.url;
      }
    }